import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteLocation = createAsyncThunk(
  'listLocations/fetchDeleteLocation',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteLocation(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteLocationSlice = createSlice({
  name: 'locations/delete',
  initialState,
  reducers: {
    resetDeleteLocation: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteLocation.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteLocation.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteLocation.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteLocationSlice.reducer
export const { resetDeleteLocation } = deleteLocationSlice.actions
